import React, { useContext, useEffect, useState } from 'react'
import { SRLWrapper } from "simple-react-lightbox";
import { Fragment } from 'react'
import { AuthContext } from '../../../App/App';
import { WhatsappContext } from './Whatsapp';
import InfiniteScroll from "react-infinite-scroll-component";
import axios from 'axios';
import swal from 'sweetalert';


function ChatBody() {
    const { stateWhatsApp, dispatchWhatsApp } = useContext(WhatsappContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    const hanleForwardClick = (chat) => {
        //show forward modal
        dispatchWhatsApp({
            type: "MODALFORWARD",
            modalforward: { status: !stateWhatsApp.modalforward.status, chat: chat }
        })
    }

    // useEffect(() => {
    //     if (stateWhatsApp.trigger.message == "get-chat-detail" && stateWhatsApp.active != null) {
    //         fetchMoreData(stateWhatsApp.active)
    //     }
    // }, [stateWhatsApp.trigger])

    const [fetch, setfetch] = useState({ status: false, row: 0, tempChatId: null })
    useEffect(() => {
        if (stateWhatsApp.active != null) {
            settempChat([])
            setfetch({ ...fetch, status: true, row: 0, tempChatId: '' })
        }
    }, [stateWhatsApp.active])
    useEffect(() => {
        if (fetch.status) {
            fetchMoreData()
        }
    }, [fetch.status])

    const fetchMoreData = () => {
        if (fetch.status != null) {
            //get chat detail
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`/api/v1/helpdesk/whatsapp/chat/admin/${stateWhatsApp.active}/${fetch.row}`, config)
                .then(res => {
                    //chek is same category filter
                    let body = fetch.tempChatId == stateWhatsApp.active ? stateWhatsApp.chat.concat(res.data.data) : res.data.data
                    //delete duplicate
                    let sameID = {}
                    body = body.filter(function (currentObject) {
                        if (currentObject.id in sameID) {
                            return true
                        } else {
                            sameID[currentObject.id] = true;
                            return true
                        }
                    })
                    //sort
                    body = body.sort((a, b) => b.time.localeCompare(a.time))
                    setfetch({ ...fetch, status: (res.data.data.length < 20) ? null : false, row: fetch.row + 20, tempChatId: stateWhatsApp.active })
                    dispatchWhatsApp({
                        type: "CHAT",
                        payload: body,
                    })
                })
                .catch(err => {
                    setfetch({ ...fetch, status: false })
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again...'
                            })
                        } else {
                            swal("Error!", `${err.response.data.message}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }

    const [downloading, setdownloading] = useState({ status: false, selected: null, image: null, tempImg: null })
    const downloadImage = (att, id) => {
        setdownloading({ ...downloading, image: { id: id, name: att } })
    }
    useEffect(() => {
        if (downloading.image != null && downloading.image.id != downloading.tempImg) {
            setdownloading({ ...downloading, tempImg: downloading.image.id })
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`/api/v1/helpdesk/whatsapp/attachment/${downloading.image.name}`, config)
                .then(res => {
                    const ChatIndex = tempChat.findIndex(chat => chat.id == downloading.image.id)
                    tempChat[ChatIndex].file = res.data.file
                    setdownloading({ ...downloading, image: null, })
                })
                .catch(err => {
                    setdownloading({ ...downloading, image: null, tempImg: null })
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again...'
                            })
                        } else {
                            swal("Error!", `${err.response.data.message}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }, [downloading.image])

    const downloadAttachment = (att) => {
        if (downloading.status == false) {
            setdownloading({ status: true, selected: att })
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`/api/v1/helpdesk/whatsapp/attachment/${att}`, config)
                .then(res => {
                    setdownloading({ status: false, selected: null, tempImg: null })
                    let a = document.createElement('a');
                    a.href = `data:${res.data.file.mime};base64,${res.data.file.data}`;
                    a.download = new Date().toLocaleString(['id-ID']).replace(/[.]/g, ' ');
                    a.target = '_blank'
                    a.click();
                })
                .catch(err => {
                    setdownloading({ status: false, selected: null, tempImg: null })
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again...'
                            })
                        } else {
                            swal("Error!", `${err.response.data.message}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }

    const [tempChat, settempChat] = useState([])
    useEffect(() => {
        if (stateWhatsApp.chat != null) {
            settempChat(stateWhatsApp.chat)
        }
    }, [stateWhatsApp.chat])

    useEffect(() => {
        if (stateWhatsApp.chats.length == 0 || stateWhatsApp.active == null) {
            settempChat([])
        } else if (stateWhatsApp.trigger.status == 'success' && (stateWhatsApp.trigger.message == 'whatsapp-chat' || stateWhatsApp.trigger.message == 'new-whatsapp-chat') && stateWhatsApp.active == stateWhatsApp.trigger.res.data.parentID) {
            let newChat = {
                chatStatus: (stateWhatsApp.trigger.message == 'new-whatsapp-chat') ? "sent" : "replies",
                content: stateWhatsApp.trigger.res.data.content,
                time: stateWhatsApp.trigger.res.data.time,
                att: stateWhatsApp.trigger.res.data.att,
                username: stateWhatsApp.trigger.res.data.username,
                id: stateWhatsApp.trigger.res.data.id,
                file: stateWhatsApp.trigger.res.data.file
            }
            newChat = tempChat.concat(newChat).sort((a, b) => b.time.localeCompare(a.time))
            dispatchWhatsApp({
                type: 'CHAT',
                payload: newChat
            })
        }
    }, [stateWhatsApp.trigger])


    const initialState = (
        <div id="scrollableDiv" style={{ height: '100%', overflow: 'auto' }}>
            <InfiniteScroll
                dataLength={0}
                next={''}
                // style={{ display: 'flex', flexDirection: 'column-reverse' }}
                hasMore={false}
                scrollableTarget="scrollableDiv"
            >
                <div className="messages">
                    <br />
                    <div className="card-body">
                        <div className="empty-state" >
                            <div className="empty-state-icon">
                                <i className="fas fa-envelope-open-text"></i>
                            </div>
                            <h2>No Message Selected</h2>
                            <p className="lead">
                                Please select the message first....
                            </p>
                        </div>
                    </div>
                </div>
            </InfiniteScroll>
        </div>
    )
    const [renderBody, setrenderBody] = useState(initialState)

    useEffect(() => {
        if (stateWhatsApp.active != null && tempChat.length > 0) {
            setrenderBody(
                <Fragment>
                    <div id="scrollableDiv" style={{ height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column-reverse', }}>
                        <InfiniteScroll
                            dataLength={tempChat.length}
                            next={fetchMoreData}
                            style={{ display: 'flex', flexDirection: 'column-reverse' }} //To put endMessage and loader to the top.
                            inverse={true} //
                            hasMore={true}
                            // loader={<h4>{fetch.status ? '...loading' : ''}</h4>}
                            scrollableTarget="scrollableDiv"
                        >
                            {tempChat.map((chat) =>
                                <div key={chat.id} className={`"${chat.chatStatus}"`} style={{ display: 'inline-block', clear: 'both', margin: '15px 0px 0px 15px', width: 'calc(100% - 30px)', fontSize: '1em' }}>
                                    <div style={{ display: 'inline-block', padding: '10px 15px', borderRadius: '20px', maxWidth: `${chat.att != null && chat.file != 'file' ? `50%` : `70%`}`, lineHeight: '130%', marginBottom: '15px', backgroundColor: `${chat.chatStatus == 'sent' ? '#6777EF' : '#f3e4e4'}`, color: `${chat.chatStatus == 'sent' ? '#fff' : '#000'}`, float: `${chat.chatStatus == 'sent' ? 'left' : 'right'}` }}>
                                        {chat.att != null ? chat.file == 'file' ? (
                                            <div className="pt-2 pb-3 pr-3 pl-3 row justify-content-md-center" onClick={() => downloadAttachment(chat.att.replace(/[/]/g, "."))}>
                                                <div className="col col-lg-auto">
                                                    <button style={{ borderRadius: '30px', textTransform: `${downloading.status && downloading.selected == chat.att ? `lowercase` : `capitalize`}` }} className="col-12 btn btn-light icon-left " contentdis rel="noopener noreferrer" >
                                                        <i className={downloading.status && downloading.selected == chat.att ? 'fas fa-spinner fa-pulse' : "fa fa-download"} ></i> {downloading.status && downloading.selected == chat.att ? `...downloading` : `Download Attachment`}
                                                    </button>
                                                </div>
                                            </div>
                                        ) : chat.file == 'img' ? (
                                            <img style={{ borderRadius: '20px', maxWidth: '100%', padding: '2px' }} src="./assets/img/image-load.gif" alt="" onClick={downloadImage(chat.att.replace(/[/]/g, "."), chat.id)} />
                                        ) : (
                                            <SRLWrapper>
                                                <img style={{ borderRadius: '20px', maxWidth: '100%', padding: '2px' }} src={`data:${chat.file.mime};base64,${chat.file.data}`} alt="" />
                                            </SRLWrapper>
                                        ) : ''}
                                        <div>
                                            <p style={{ fontSize: '13px' }}>
                                                {chat.content != '' ? chat.content.split('\n').map((item, key) => (<Fragment key={key}>{item.replace(/'\\t'/g, ' ')}<br /></Fragment>)) : null}
                                                <span className="align-self-end" style={{ cursor: 'pointer', paddingRight: `${chat.chatStatus == 'sent' ? '0px' : '10px'}`, paddingLeft: `${chat.chatStatus == 'sent' ? '10px' : '0px'}`, float: `${chat.chatStatus == 'sent' ? 'right' : 'left'}` }} onClick={hanleForwardClick.bind(this, chat)}><i className="fas fa-share-square" style={{ display: `inline-block`, borderRadius: `60px`, boxShadow: `0px 0px 2px #ffffff00`, padding: `0.5em 0.6em` }}></i></span>
                                                <small style={{ fontSize: '10px' }}>{`${new Date(chat.time).toISOString().replace(/T/, ' ').replace(/\..+/, '')} ${(chat.chatStatus == 'replies' ? ` - ${chat.username}` : '')}`}</small>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </InfiniteScroll>
                    </div>
                </Fragment>
            )
        } else {
            setrenderBody(initialState)
        }
    }, [tempChat, downloading.tempImg, downloading.status,])

    return (
        <Fragment>
            <div className="card-body chat-content pl-0 ml-0 overflow-auto" style={{ backgroundColor: (stateWhatsApp.active != null) ? '#f9f9f9' : '#fff' }}>
                {renderBody}
            </div>
        </Fragment >
    )
}

export default ChatBody
